import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createBlock as _createBlock, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createTextVNode as _createTextVNode, toDisplayString as _toDisplayString, createCommentVNode as _createCommentVNode, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-c6c23be0")

_pushScopeId("data-v-c6c23be0")
const _hoisted_1 = /*#__PURE__*/_createTextVNode("确定")
const _hoisted_2 = { style: {"background":"#fff","border":"1px solid #dcdfe6","border-radius":"4px","padding":"5px"} }
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_el_option = _resolveComponent("el-option")
  const _component_el_select = _resolveComponent("el-select")
  const _component_el_form_item = _resolveComponent("el-form-item")
  const _component_el_button = _resolveComponent("el-button")
  const _component_el_form = _resolveComponent("el-form")
  const _component_el_image = _resolveComponent("el-image")
  const _component_el_main = _resolveComponent("el-main")
  const _component_el_container = _resolveComponent("el-container")

  return (_openBlock(), _createBlock(_component_el_container, null, {
    default: _withId(() => [
      _createVNode(_component_el_container, null, {
        default: _withId(() => [
          _createVNode(_component_el_main, null, {
            default: _withId(() => [
              _createVNode(_component_el_form, {
                inline: true,
                size: "mini"
              }, {
                default: _withId(() => [
                  _createVNode(_component_el_form_item, {
                    class: "version_input",
                    label: "选择用例"
                  }, {
                    default: _withId(() => [
                      _createVNode(_component_el_select, {
                        modelValue: _ctx.info,
                        "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => (_ctx.info = $event)),
                        placeholder: "请选择",
                        filterable: ""
                      }, {
                        default: _withId(() => [
                          (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.monList, (item) => {
                            return (_openBlock(), _createBlock(_component_el_option, {
                              key: item.id,
                              label: item.info,
                              value: item.id
                            }, null, 8, ["label", "value"]))
                          }), 128))
                        ]),
                        _: 1
                      }, 8, ["modelValue"])
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_el_form_item, { class: "version_input" }, {
                    default: _withId(() => [
                      _createVNode(_component_el_button, {
                        type: "primary",
                        onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.confirm()))
                      }, {
                        default: _withId(() => [
                          _hoisted_1
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              }),
              _createVNode("div", null, [
                _createVNode("div", _hoisted_2, [
                  _createVNode("div", null, _toDisplayString(_ctx.monText.info), 1),
                  (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.monText.case, (item, k, i) => {
                    return (_openBlock(), _createBlock("div", {
                      style: {"margin-bottom":"10px"},
                      key: i
                    }, [
                      _createVNode("div", null, _toDisplayString(k), 1),
                      (_openBlock(true), _createBlock(_Fragment, null, _renderList(item.res, (v) => {
                        return (_openBlock(), _createBlock("div", { key: v }, [
                          _createVNode("div", null, _toDisplayString(v), 1)
                        ]))
                      }), 128)),
                      (item.image)
                        ? (_openBlock(), _createBlock(_component_el_image, {
                            key: 0,
                            src: item.image
                          }, null, 8, ["src"]))
                        : _createCommentVNode("", true)
                    ]))
                  }), 128))
                ])
              ])
            ]),
            _: 1
          })
        ]),
        _: 1
      })
    ]),
    _: 1
  }))
})